
export enum AccountTypeName {
  Bank = 'BANK',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  OtherCurrentAsset = 'OTHER_CURRENT_ASSET',
  FixedAsset = 'FIXED_ASSET',
  OtherAsset = 'OTHER_ASSET',
  Inventory = 'INVENTORY',
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  LoanPayable = 'LOAN_PAYABLE',
  CreditCard = 'CREDIT_CARD',
  OtherCurrentLiability = 'OTHER_CURRENT_LIABILITY',
  LongTermLiabilities = 'LONG_TERM_LIABILITIES',
  Equity = 'EQUITY',
  Income = 'REVENUE',
  OtherIncome = 'OTHER_INCOME',
  OtherRevenue = 'OTHER_REVENUE',
  OtherExpense = 'OTHER_EXPENSE',
  COGS = 'COST_OF_GOODS_SOLD',
  OperationalExpense = 'OPERATIONAL_EXPENSE',
  Unallowable = 'UNALLOWABLE',
  Offset = 'INDIRECT_ALLOCATION_OFFSET',
  Applied = 'INDIRECT_ALLOCATION_APPLIED'

}

export enum AccountGroupType {
  Labor = 'LABOR',
  Expense = 'EXPENSE',
  Purchase = 'PURCHASE',
  Revenue = 'REVENUE'
}

export enum AccountMappingType {
  Income = 'REVENUE',
  Cogs = 'COST_OF_GOODS_SOLD',
  OperationalExpense = 'OPERATIONAL_EXPENSE',
  Inventory = 'INVENTORY',
  FixedAsset = 'FIXED_ASSET',
  OtherCurrentAsset = 'OTHER_CURRENT_ASSET',
  OtherCurrentLiability = 'OTHER_CURRENT_LIABILITY',
  Unallowable = 'UNALLOWABLE'
}

export enum ExpenseCategoryType {
  Labor = 'LABOR',
  Travel = 'TRAVEL',
  Materials = 'MATERIALS',
  SubContractor = 'SUBCONTRACTOR',
  Other = 'OTHER'
}

